import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './types';

export const queryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 3,
      retryDelay: (attemptIndex: number) =>
        Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: !__DEV__,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
    },
  },
};

export const queryClient = new QueryClient(queryClientConfig);

export const handleQueryError = (error: ApiError) => {
  if (__DEV__) {
    console.error('Query Error:', error);
  }
};

